module.exports = __webpack_public_path__ + "media/images/icon__plus@3x-2e11263561bc1f52af57a9b1d8f50ee2.png";